'use client';

import { useEffect } from 'react';
import { createScarletSyncWebMcpTools } from '@/app/lib/webMcp';
import { readAssistantPageContext } from '@/app/Components/Assistant/pageContext';

export default function WebMcpProvider() {
  useEffect(() => {
    const modelContext = document.modelContext;
    if (!modelContext?.registerTool || !window.isSecureContext) return;

    const controller = new AbortController();
    const tools = createScarletSyncWebMcpTools({
      fetch: window.fetch.bind(window),
      getOrigin: () => window.location.origin,
      getPathname: () => window.location.pathname,
      getPageContext: readAssistantPageContext,
    });

    void (async () => {
      for (const tool of tools) {
        if (controller.signal.aborted) return;
        try {
          await modelContext.registerTool(tool, { signal: controller.signal });
        } catch (error) {
          if (controller.signal.aborted || (error instanceof DOMException && error.name === 'AbortError')) return;
          if (process.env.NODE_ENV === 'development') {
            console.warn(`[WebMCP] Could not register ${tool.name}`, error);
          }
        }
      }
    })();

    return () => controller.abort();
  }, []);

  return null;
}
